import routesHelper from "../libraries/universal-route/helper";
import ApplicationForm from "../components/hiring/ApplicationForm";
import JobDescription from "../components/hiring/JobDescription";
import Jobs from "../components/hiring/Jobs";
import NotFound from "../components/hiring/404";
import Availability from "../components/hiring/Availability";
import CtaForm from "../components/hiring/CtaForm";

export default routesHelper.prepare({
  "/404": NotFound,
  "/:slug/booking/:token": Availability,
  "/:slug/booking/:token/:tz": Availability,
  "/:slug/booking/:token/:tz/:date": Availability,
  "/:slug/jobs": Jobs,
  "/:slug/jobs/:jobId": JobDescription,
  "/:slug/view/:hashId/jobs/:jobId": JobDescription,
  "/jobs/:jobId/preview": JobDescription,
  "/:slug/jobs/:jobId/apply": ApplicationForm,
  "/:slug/forms/:contentSectionId": CtaForm
});
